import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { FilterOneItem } from "@/shared/components/GenericSearchBar/model/FilterOneItem";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const DEPENDENCIES_CONSTANTS = {
  URL_ROUTE: "/dependencies",
  TITLE: {
    PPAL_PAGE: "Dependencias",
    ADD_DEPENDENCY: "Agregar dependencia",
    EDIT_DEPENDENCY: "Editar dependencia"
  },
  LABEL: {
    ADD_DEPENDENCY: "Crear dependencia",
    NAME: "Nombre *",
    SEL_USERS: "Usuario por",
    HINT_USERS: "Seleccione usuarios de la lista",
    HINT_SEARCH_USER:
      "Escriba el valor a buscar del usuario y presiona enter para buscar",
    SEARCH_USER: "Búsqueda de usuarios",
    EMPTY_TITLE: "No hay información para mostrar",
    EMPTY_TEXT_FILTER: "No se encuentra Usuarios asociados a esta Dependencia"
  },
  MESSAGES: {
    DEPENDENCY_USED:
      "La dependencia se encuentra en uso, no puede ser eliminada."
  },
  BUTTON: {
    LOAD_MORE_OPTIONS: "Cargar más opciones"
  },
  TYPE_FILTER: {
    LOADING: "loading"
  },
  SNACKBAR_MESSAGES: {
    SAVE_SUCCESS: ""
  },
  USER_FILTERS: ["Nombre", "Teléfono", "Identificación"]
};

export const PAGINATION_USER = 20;

export const EMITS = {
  CLOSE_MODAL: "onCloseModal",
  SAVE_MODAL: "onSaveModal"
};

export const DEPENDENCIES_FILTERS: Filter[] = [
  {
    mainFilterKey: "dependencies",
    mainFilterName: "Dependencias",
    avatar: "mdi-shape-plus",
    initial: true,
    placeholder: "Seleccione los filtros deseados para las Dependencias",
    secondaryFilters: [
      {
        name: "Nombre",
        placeholder: "Nombre de Dependencia",
        key: "name",
        display: "unique",
        default: true,
        operators: OPERATORS_FILTERS,
        type: "secondaryFilter"
      },
      {
        default: false,
        name: "Estado",
        placeholder: "Estado de Dependencia",
        key: "state",
        type: "secondaryFilter",
        display: "list",
        options: [
          { key: "Activo", name: "Activo" },
          { key: "Inactivo", name: "Inactivo" }
        ],
        operators: OPERATORS_FILTERS
      }
    ]
  }
];

export const FILTER_QUERY_DEFAULT_DEPENDENCIES = {
  userState: "Activo",
  externalUser: true
};

export const FILTER_SEARCH_USER_DEPENDENCIES: FilterOneItem = {
  labelTitle: " del usuario",
  labelNotFound: "No se encontró usuario para esa busqueda",
  labelAddTitle: "No se encontró usuario con esta busqueda",
  labelAddSubTitle: " Crear nuevo usuario",
  addIcon: "mdi-plus-circle-outline",
  defaultUpdate: "userDocument",
  persistentList: true,
  filters: [
    { name: "Nombre", id: "name", default: true },
    {
      name: "Documento",
      id: "userDocument"
    },
    { name: "Correo", id: "userEmail" }
  ]
};

export const DEPENDENCIES_ACCESS = {
  GET: "consultar dependencias",
  POST: "crear dependencias",
  PUT: "modificar dependencias",
  DELETE: "eliminar dependencias"
};

export const DEPENDENCIES_MESSAGES = {
  REQUEST_FAILED: "Ha ocurrido un error, intente más tarde.",
  FORBIDDEN_REQUEST: "Acceso denegado, no tiene permiso para "
};
